import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomBanner, IntellioHttpResponse } from '@intellio/shared/models';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class CustomBannerService extends BaseService {
  private readonly endpoint = '/api/supportcenter/custombanner';

  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getCustomBanner(): Observable<IntellioHttpResponse<CustomBanner>> {
    return this.get<CustomBanner>(this.endpoint);
  }

  upsertCustomBanner(
    banner: CustomBanner
  ): Observable<IntellioHttpResponse<CustomBanner>> {
    return this.put<CustomBanner>(this.endpoint, banner);
  }

  deleteCustomBanner(): Observable<IntellioHttpResponse<unknown>> {
    return this.delete<unknown>(this.endpoint);
  }
}
